import { PropsWithChildren } from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';
import { Slot } from '@radix-ui/react-slot';

export interface WithTooltipProps {
  tooltip: string;
  className?: string;
  disabled?: boolean;
}

export function WithTooltip({
  tooltip,
  disabled,
  className,
  ...props
}: PropsWithChildren<WithTooltipProps>) {
  if (disabled) {
    return <Slot {...props} />;
  }

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Slot {...props} />
        </TooltipTrigger>
        <TooltipContent side="top" sideOffset={5} className={className}>
          <p className="text-sm">{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
